import Vue from 'vue'

import Cookies from 'js-cookie'

import './plugins/index.js'
import '@/assets/tailwindcss.css'

import 'normalize.css/normalize.css'

import directive from './directive'
import baseApi from './api/base/index'
import api from '@/api/qualityControl/wocenter'

import { VueAxios } from '@/utils/qualityControl/request'
import Element from 'element-ui'
Vue.prototype.$eventBus = new Vue()
//
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

// 数据字典
import dict from './components/Dict'

import { download } from '@/utils/request.js'

import './plugin/lodash.js'

import 'ant-design-vue/dist/antd.less'
// 权限指令
import checkPer from '@/utils/permission'
import './assets/styles/element-variables.scss'
// global css
import './assets/styles/index.scss'
import './assets/styles/qualityControl/css/global.less'
import './assets/styles/unifiedStyle.scss'
// 代码高亮
import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/styles/atom-one-dark.css'

import App from './App'
import store from './store'
import Antd from 'ant-design-vue'

import router from './router/routers'

import './assets/icons' // icon
import './router/index' // permission control
import 'echarts-gl'

import 'xe-utils'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import componentRegister from '@/plugin/componentRegister'
import utilRegister from '@/plugin/utilRegister'
import globalFilters from '@/utils/qualityControl/globalFilters'

import commonSearchRegister from '@/plugin/commonSearchRegister'

Object.keys(globalFilters).forEach(filterKey => {
  Vue.filter(filterKey, globalFilters[filterKey])
})

Vue.use(Avue)
Vue.use(componentRegister)
Vue.use(utilRegister)

Vue.use(VueAxios)
Vue.use(VXETable)
Vue.use(Antd)
Vue.prototype.$antdconfirm = Vue.prototype.$confirm
Vue.prototype.$download = download

Vue.prototype.$baseApi = baseApi
Vue.prototype.$api = api
Vue.use(checkPer)
Vue.use(VueHighlightJS)
Vue.use(directive)
Vue.use(mavonEditor)
Vue.use(dict)
Vue.use(commonSearchRegister)
Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // set element-ui default size
  zIndex: 10000
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

